<template>
  <div :class="isSticky ? 'fixed header-box' : 'header-box'">
      <div class="main-box">
        <div class="site-logo">
          <img src="@/assets/image/logo1.png" alt="华锋新能源" />
          <img src="@/assets/image/logo11.png" alt="北京理工华创" class="logo"/>
          <!-- <div class="site-title">北京理工华创</div> -->
        </div>
        <div class="navWrap">
          <ul class="navList">
            <li
              class="menu_one_box"
              v-for="(item, index) in menuItems"
              :key="index"
              :class="{ active: item.active }"
              @click="changeCategory(item)"
            >
              {{ item.label }}
              <ul class="menu_two_box">
                <li v-for="(itm, ind) in item.children" :key="ind"
                :class="{ active: itm.active }"
                @click.stop="changeCategory(itm)"
                >
                  {{ itm.label }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      languageData: ["ZH", "EN"],
      // currentIndex: 0,
      currentInd: 0,
      categoryList: [
        { value: "首页", label: "首页", path: '/Home' },
        {
          value: "新闻资讯",
          label: "新闻资讯",
          path: '/NewPageAll',
          children: [
            { value: "公司动态", label: "公司动态", path: '/NewPageList/1' },
            { value: "行业新闻", label: "行业新闻", path: '/NewPageList/2' },
          ],
        },
        {
          value: "产品中心",
          label: "产品中心",
          path: '/ProductCategoryAll',
          children: [
            { value: "整车控制器", label: "整车控制器", path: '/ProductList/1' },
            { value: "电驱动与传动系统", label: "电驱动与传动系统", path: '/ProductList/2' },
            { value: "高压集成控制器", label: "高压集成控制器", path: '/ProductList/3' },
            { value: "其他高压附件", label: "其他高压附件", path: '/ProductList/4' },
          ],
        },
        {
          value: "案例展示",
          label: "案例展示",
          path: '/Case',
          children: [
            { value: "典型案例", label: "典型案例", path: '/NewPageList/3' },
            { value: "科技项目", label: "科技项目", path: '/NewPageList/4' },
          ],
        },
        {
          value: "服务支持",
          label: "服务支持",
          path: '/ServicePage',
          children: [
            { value: "技术服务", label: "技术服务", path: '/ServicePage?model=7' },
            { value: "售后服务", label: "售后服务", path: '/ServicePage?model=8' },
          ],
        },
        {
          value: "关于我们",
          label: "关于我们",
          path: '/AboutUsPage',
          children: [
            { value: "公司介绍", label: "公司介绍", path: '/AboutUsPage?model=9' },
            { value: "管理团队", label: "管理团队", path: '/AboutUsPage?model=10' },
            { value: "招贤纳士", label: "招贤纳士", path: '/AboutUsPage?model=11' },
            { value: "发展战略", label: "发展战略", path: '/AboutUsPage?model=12' },
            { value: "联系我们", label: "联系我们", path: '/AboutUsPage?model=5' },
          ],
        },
      ],
      isSticky: false,//吸顶
      activePath: ''
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize)

    // 监听路由变化
    this.$router.afterEach(route => {
      this.activePath = route.path;
    });
  },
  created() {
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll,true)
  },
  methods: {
    handleResize() {
      this.isSticky = window.innerWidth < 750;
      if(window.innerWidth < 750) {
        window.removeEventListener('scroll', this.handleScroll,true)
      }else{
        window.addEventListener("scroll", this.handleScroll,true);
      }
    },
    handleScroll(ev) {
      this.isSticky = ev.target.scrollTop > 1;
    },
    changeCategory(item) {
      // console.log(item)
      this.$router.push(item.path);
    },
    isActive(menuItem) {
      if (this.$route.path === menuItem.path) {
        return true;
      }
      // 递归查找父菜单项，并标记为选中状态
      if (menuItem.children) {
        for (const child of menuItem.children) {
          if (this.$route.path === child.path) {
            return true;
          }
          if (child.children) {
            const grandChildActive = child.children.some(grandChild => this.$route.path === grandChild.path);
            if (grandChildActive) {
              return true;
            }
          }
        }
      }
      return false;
    },
  },
  computed: {
    menuItems() {
      return this.categoryList.map(item => ({
        ...item,
        active: this.isActive(item),
        children: item.children && item.children.map(child => ({
          ...child,
          active: this.isActive(child),
        })),
      }));
    },
  },
};
</script>

<style lang="scss"  scoped >
.fixed-nav {
  position: fixed;
  top: 200;
  z-index: 999;
}
.header-box {
  width: var(--fixed-width);
  background: rgba(255,255,255,0.2);
  color: #1a46a7;
  height: 110px;
  position: absolute;
  top: 0;
  font-weight: 600;
  z-index: 999;
  transition: all 0.45s ease-in-out;
    .main-box {
      width: var(--base-width);
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media only screen and (min-width: 300px) and (max-width: 768px) {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
      }
      .site-logo {
        width: 20%;
        display: flex;
        align-items: center;
        img {
          height: 40px;
          @media only screen and (min-width: 300px) and (max-width: 768px) {
            height: 18px;
          }
        }
        .logo {
          // width: 40px;
          height: 45px;
          margin-left: 4px;
          @media only screen and (min-width: 300px) and (max-width: 768px) {
            // width: 18 px;
          // height: 40px;
          }
        }
        .site-title {
          font-size: 16px;
          // color: #fff;
          margin-left: 5px;
          @media only screen and (min-width: 300px) and (max-width: 768px) {
            display: none;
          }
        }
      }
      .navWrap {
        width: 75%;

        .navList {
          width: 100%;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          list-style: none;
          @media only screen and (min-width: 300px) and (max-width: 768px) {
            height: 50px;
          }
          .menu_one_box {
            cursor: pointer;
            font-size: 16px;
            position: relative;
            flex: 1;
            max-width: 180px;
            min-width: 50px;
            text-align: center;
            line-height: 110px;
            @media only screen and (min-width: 300px) and (max-width: 768px) {
              font-size: 12px;
              // width: 70px;
              // line-height: 30px;
            }
            &::after {
              content: "";
              display: block;
              width: 0;
              height: 6px;
              background: #26a3de;
              border-radius: 10px;
              position: absolute;
              bottom: 0;
              left: 0;
              transition: all 0.5s ease 0s;
            }
            &:hover::after {
              width: 100%;
            }
            &:hover .menu_two_box {
              display: block;
            }
            .menu_two_box {
              background: #fff;
              position: absolute;
              top: 110px;
              width: 110%;
              margin-left: -5%;
              display: none;
              font-size: 14px;
              font-weight: 400;
              z-index: 99;
              line-height: 44px;
              border-radius: 0 0 4px 4px;
              box-shadow: 0 0 6px rgba(0,0,0, .12);
              padding: 4px 0;
              @media only screen and (min-width: 300px) and (max-width: 768px) {
                font-size: 12px;
                width: 70px;
                line-height: 30px;
              }
              li{
                width: 90%;
                margin: auto;
                border-bottom: 1px solid #eee;
                border-radius: 4px;
              }
              li.active,
              li:hover {
                background: #eee;
              }
            }
          }
          .menu_one_box.active {
            background: rgba(255,255,255,0.2);
          }
          .menu_one_box.active::after {
            width: 100%;
          }
        }
      }

      .About_box {
        height: 100%;
        display: flex;
        align-items: center;
        .navList {
          width: 100%;
          height: 150px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          list-style: none;
          img {
            width: 30px;
            height: 30px;
          }
          .menu_one_box {
            cursor: pointer;
            font-size: 16px;
            color: #fff;
            position: relative;
            width: 50px;
            text-align: center;
            &:hover .menu_two_box {
              display: block;
            }
            .menu_two_box {
              position: absolute;
              top: 40px;
              width: 110px;
              height: 110px;
              border-radius: 10px;
              background: #fff;
              display: none;
              img {
                width: 90px;
                height: 90px;
                padding: 10px;
              }
            }
          }
        }
      }
      .site-EndWrap {
        height: 100%;
        display: flex;
        align-items: center;
        ul {
          height: 15px;
          display: flex;
          align-items: center;
          gap: 12px;
          background-color: rgba(255, 255, 255, 0.6);
          color: rgba(0, 13, 26, 0.3);
          font-size: 12px;
          padding: 5px 8px;
          border-radius: 50px;
          cursor: pointer;
          @media only screen and (min-width: 300px) and (max-width: 768px) {
            height: 15px;
            display: flex;
            align-items: center;
            gap: 5px;
            background-color: rgba(255, 255, 255, 0.6);
            color: rgba(0, 13, 26, 0.3);
            font-size: 8px;
            padding: 5px 5px;
            border-radius: 50px;
            cursor: pointer;
          }
        }
        .active {
          background-color: #99aeff;
          display: flex;
          align-items: center;
          color: #fff;
          height: 11px;
          padding: 5px 8px;
          border-radius: 50px;
          @media only screen and (min-width: 300px) and (max-width: 768px) {
            height: 15px;
            display: flex;
            align-items: center;
            gap: 5px;
            background-color: rgba(255, 255, 255, 0.6);
            color: #fff;
            font-size: 8px;
            padding: 5px 5px;
            border-radius: 50px;
            cursor: pointer;
            background-color: #99aeff;
          }
        }
      }
    }
}

.header-box.fixed {
  position: fixed;
  background: rgba(255,255,255,1);
  height: 44px;
  border-bottom: 1px solid #f0f1f2;
  transition: all 0.45s ease-in-out;
  font-weight: 400;
}
.header-box.fixed .main-box .navWrap .navList .menu_one_box {
  line-height: 44px;
}
.header-box.fixed .main-box .navWrap .navList .menu_one_box .menu_two_box {
    top: 44px;
}
</style>



// WEBPACK FOOTER //
// src/view/layout/Header.vue